import { Fade, FormControlLabel, Grid } from '@mui/material';
import { FC } from 'react';

import { ApiUserType } from '../../../../api/def_common_api';
import { useActions } from '../../../../hooks/useActions';
import UpdateOrg from '../../../../ui/checkout/UpdateOrg/UpdateOrg';
import CheckoutDialog from '../CheckoutDialog';
import CheckoutFields from '../CheckoutFields/CheckoutFields';

import AddRegistration from './AddRegistration';
import styles from './ContactInformation.module.sass';
import Switches from './Switches';
import { useContactInformation } from './useContactInformation';

const ContactInformation: FC = () => {
  const { setHandleModal } = useActions();
  const {
    isUserOrg,
    profile,
    onClearValue,
    toggleSwitch,
    entityTab,
    setEntityTab,
  } = useContactInformation();

  return (
    <div className={styles.wrapper}>
      <Grid container spacing={2} columns={{ xs: 1, sm: 8, md: 12 }}>
        <Grid item lg={10} md={7} xs={8}>
          <div className={styles.contacts}>
            <h1 className={styles.title}>Контактная информация</h1>
            <div className={styles.fields}>
              <CheckoutFields />
            </div>
          </div>
        </Grid>
        <Grid item lg={4} md={5} xs={4}>
          <div className={styles.top}>
            <FormControlLabel
              control={
                <Switches
                  toggleSwitch={toggleSwitch}
                  entityTab={entityTab}
                  setEntityTab={setEntityTab}
                />
              }
              label=""
            />
          </div>
          <Fade in={entityTab} unmountOnExit>
            <div>
              <AddRegistration
                user={profile}
                isUserOrg={isUserOrg}
                setHandleModal={setHandleModal}
                onClearValue={onClearValue}
              />
            </div>
          </Fade>
          <CheckoutDialog content={<UpdateOrg />} />
        </Grid>
      </Grid>
    </div>
  );
};

export default ContactInformation;
